var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15722 20.433V17.3663C8.1572 16.5863 8.79312 15.9524 9.58101 15.9472H12.4671C13.2587 15.9472 13.9005 16.5826 13.9005 17.3663V17.3663V20.4425C13.9003 21.1048 14.4343 21.6461 15.103 21.6616H17.0271C18.9451 21.6616 20.5 20.1223 20.5 18.2235V18.2235V9.49946C20.4898 8.75245 20.1355 8.05097 19.538 7.59465L12.9577 2.34692C11.8049 1.43319 10.1662 1.43319 9.01342 2.34692L2.46203 7.60418C1.86226 8.05864 1.50739 8.76129 1.5 9.50898V18.2235C1.5 20.1223 3.05488 21.6616 4.97291 21.6616H6.89696C7.58235 21.6616 8.13797 21.1116 8.13797 20.433V20.433",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.65fb2ebcfb2a0f0332978d2bb1c25048.svg";
export { ForwardRef as ReactComponent };